var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-topic-search"},[_c('TopicSearchPanel',{ref:"search",attrs:{"show":true},on:{"cancel":_vm.goBack,"select":_vm.viewTopicDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }